export default function LatinAmericaSvg({
  className,
  style,
}: {
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <svg
      viewBox='0 0 468 239'
      preserveAspectRatio='xMidYMid meet'
      aria-label='Latin America'
      className={className}
      style={style}
    >
      <g
        transform='matrix(0.044729,0,0,-0.044729,-35.277778,510.495974)'
        fill='currentColor'
      >
        <g transform='matrix(14.148474,0,0,-14.148474,0,14089.522107)'>
          <path d='M322,299L335,299L348,304L364,306L363.015,305.877L367,302L373,302L378,309L380,313L387,318L392,313L398,316L404,326L405,330L409,333L417,335L409,350L406,363L409,374L412,383L420,389L427,387L436,385L440,380L444,373L448,369L463,368L463,375L456,387L452,395L449,403L453,403L460,402L469,402L473,404L476,407L476,416L475,419L474,423L472,433L473,434L475,438L477,440L478,442L481,444L484,445L488,445L494,441L495,442L495,445L491,449L489,450L490,452L490,454L489,456L485,457L483,454L482,455L480,454L481,451L477,450L475,451L473,450L470,448L470,444L466,440L464,442L459,437L460,434L460,432L451,422L451,419L444,419L439,417L430,414L425,409L421,404L417,402L412,403L409,404L405,405L392,399L386,396L378,390L374,390L363,380L362,377L363,374L364,372L364,362L362,359L349,343L348,341L350,338L345,334L345,330L340,325L338,324L337,322L339,320L339,310L336,307L332,307L331,309L330,314L331,318L333,319L335,321L334,323L334,325L335,326L335,330L339,339L340,343L340,346L342,347L341,349L343,351L345,352L345,358L344,359L341,360L340,356L338,353L333,350L332,348L335,343L333,340L323,332L322,329L327,329C327,329 329.645,325.106 327,323C324.355,320.894 323,318 323,318L322,299Z' />
        </g>
        <g transform='matrix(14.148474,0,0,-14.148474,0,14089.522107)'>
          <path d='M473,366C473,366 478.006,358.337 488,358C497.994,357.663 499,359 499,359L504,362L507,362L510,363L529,376L528,378L510,378L509,376L512,375L512,374L508,374L506,371L506,368L500,368L494,365L491,365L489,364L489,362L485,362L483,364L479,366' />
        </g>
      </g>
    </svg>
  );
}
